module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n<div class="b-tour-component">\n	<div class="b-tour-component__image">\n		<img src="' + require("/app/node_modules/underscore-template-loader/file-loader.js?url=.%2Fimages%2Fmeal.svg!./images/meal.svg") + '" alt="Питание на выбор">\n	</div>\n	<div class="b-tour-component__text">\n		Питание на выбор\n	</div>\n</div>';
}
return __p;
};
